import { z } from 'zod';

import { ConnectionType } from './common.js';

export enum FivetranState {
  Active = 'Active',
  Syncing = 'Syncing',
  Error = 'Error',
  Inactive = 'Inactive',
}

export const ConnectionIntegrationEngineSchema = z.object({
  connectionType: z.literal(ConnectionType.IntegrationEngine),
  connectionId: z.string(),
  name: z.string(),
  source: z.string(),
  destination: z.string(),
  method: z.string(),
  dataType: z.string(),
  organizationId: z.string(),
  detailPath: z.string(),
  lastActivityAt: z.string().nullable(),
  updated: z.string(),
  fivetranConnectionId: z.string(),
  fivetranGroupId: z.string(),
  fivetranService: z.string(),
  state: z.enum(FivetranState),
});

export type ConnectionIntegrationEngine = z.infer<typeof ConnectionIntegrationEngineSchema>;
